

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";


@Component({
  templateUrl: "./dialog-aggiungi-configurazione.component.html",
  styleUrls: ["../listino.component.css"],
})
export class AggiungiRegioneComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  protected listino:Listino   ;
  public aggiungiConfigurazioneForm: FormGroup;
  public regioniLibere:string[]=[];
   
  protected isAddingConfiguration:Boolean = false;

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private listiniService:ListiniService,
  ) {
    this.listino = this.config.data.listino;
    if(!this.listino.liguria1){
      this.regioniLibere.push('LIGURIA');
    }
    if(!this.listino.piemonte1){
      this.regioniLibere.push('PIEMONTE');
    }
    if(!this.listino.sardegna1){
      this.regioniLibere.push('SARDEGNA');
    }
    this.aggiungiConfigurazioneForm = this._formBuilder.group({
      regione :                       [null],
      scl1:                       [null, [Validators.required]],
      scl2:                       [null, [Validators.required]],
      scl3:                       [null, [Validators.required]],
      scl4:                       [null, [Validators.required]],
      scl5:                       [null, [Validators.required]],
      preventivoBase:       [null, [Validators.required]]
    });
    
  }

  ngOnInit(): void {
    
    this.aggiungiConfigurazioneForm.get('scl2')?.valueChanges.subscribe(() => this.updatePreventivoBase());
    this.aggiungiConfigurazioneForm.get('scl3')?.valueChanges.subscribe(() => this.updatePreventivoBase());
    this.aggiungiConfigurazioneForm.get('scl5')?.valueChanges.subscribe(() => this.updatePreventivoBase());

   
  }

  getColoreRegione(regione:string):string{
    if(regione==='LIGURIA'){
      return "#37505C";
    }else if(regione==='PIEMONTE'){
      return "#C67C4E";
    }else if(regione==='SARDEGNA'){
      return "#615573";
    }
    return "#615573";
  }

  
  updatePreventivoBase() {
    const scl2 = this.aggiungiConfigurazioneForm.get('scl2')?.value || 0;
    const scl3 = this.aggiungiConfigurazioneForm.get('scl3')?.value || 0;
    const scl5 = this.aggiungiConfigurazioneForm.get('scl5')?.value || 0;
    this.aggiungiConfigurazioneForm.get('preventivoBase')?.setValue(scl2 + scl3 + scl5, { emitEvent: false });
  }
  

  

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      this.isAddingConfiguration = true;
      if(this.aggiungiConfigurazioneForm.value.regione === 'LIGURIA'){
        this.listino.liguria1               = this.aggiungiConfigurazioneForm.value.scl1;
        this.listino.liguria2               = this.aggiungiConfigurazioneForm.value.scl2;
        this.listino.liguria3               = this.aggiungiConfigurazioneForm.value.scl3;
        this.listino.liguria4               = this.aggiungiConfigurazioneForm.value.scl4;
        this.listino.liguria5               = this.aggiungiConfigurazioneForm.value.scl5;
        this.listino.preventivoBaseLiguria  = this.aggiungiConfigurazioneForm.value.preventivoBase;
      }else if(this.aggiungiConfigurazioneForm.value.regione === 'PIEMONTE'){
        this.listino.piemonte1               = this.aggiungiConfigurazioneForm.value.scl1;
        this.listino.piemonte2               = this.aggiungiConfigurazioneForm.value.scl2;
        this.listino.piemonte3               = this.aggiungiConfigurazioneForm.value.scl3;
        this.listino.piemonte4               = this.aggiungiConfigurazioneForm.value.scl4;
        this.listino.piemonte5               = this.aggiungiConfigurazioneForm.value.scl5;
        this.listino.preventivoBasePiemonte  = this.aggiungiConfigurazioneForm.value.preventivoBase;
      }else if(this.aggiungiConfigurazioneForm.value.regione === 'SARDEGNA'){
        this.listino.sardegna1               = this.aggiungiConfigurazioneForm.value.scl1;
        this.listino.sardegna2               = this.aggiungiConfigurazioneForm.value.scl2;
        this.listino.sardegna3               = this.aggiungiConfigurazioneForm.value.scl3;
        this.listino.sardegna4               = this.aggiungiConfigurazioneForm.value.scl4;
        this.listino.sardegna5               = this.aggiungiConfigurazioneForm.value.scl5;
        this.listino.preventivoBaseSardegna  = this.aggiungiConfigurazioneForm.value.preventivoBase;
      } 
     

       this.listiniService.modifica(this.listino).subscribe( {
        next: (resAggiungiRegione) => {
          this.isAddingConfiguration = false;
          this.dialogRef.close({ success: true });
        },
        error: (e) => {
            this.isAddingConfiguration = false;
            this.logger.error(e);
            this.dialogRef.close({ success: false });
            this.messageService.add({
              severity: "error",
              summary: "ATTENZIONE",
              detail: "Errore in fase di aggiunta della regione "+this.aggiungiConfigurazioneForm.value.regione+" al listino!", life:10000
            });
      },
        complete: () => {

          //this.isLoadingResults = false;
        }
    }); 
    }
  }
}
